import AblyEcho from "@ably/laravel-echo";
import * as Ably from "ably";
import { watch } from "vue";

export default defineNuxtPlugin({
  name: 'echo',
  dependsOn: ['http', 'auth-init'],
  setup() {
    const { $http, $config } = useNuxtApp();
    const { isAuthenticated } = useAuth();

    if (true) {
      globalThis.Ably = Ably;
    }

    let echoInstance = null;

    const createEcho = () => {
      if (!echoInstance) {
        echoInstance = new AblyEcho({
          broadcaster: "ably",
          requestTokenFn: async (channelName, existingToken) => {
            const postData = { channel_name: channelName, token: existingToken };
            const res = await $http.post(
              $config.public.apiBase + "/api/v2/broadcasting/auth",
              postData
            );
            return res.data;
          },
        });
      }
      return echoInstance;
    };

    const teardownEcho = () => {
      if (!echoInstance) return;
      echoInstance.leaveAll?.();
      echoInstance.disconnect?.();
      echoInstance = null;
    };

    const noopChannel = {
      listen: () => noopChannel,
      stopListening: () => noopChannel,
      listenForWhisper: () => noopChannel,
      whisper: () => noopChannel,
      here: () => noopChannel,
      joining: () => noopChannel,
      leaving: () => noopChannel,
    };

    const echo = new Proxy(
      {},
      {
        get(_target, prop) {
          const inst = isAuthenticated.value ? createEcho() : null;
          if (!inst) {
            if (prop === "private" || prop === "channel" || prop === "join") {
              return () => noopChannel;
            }
            return () => { };
          }
          const value = inst[prop];
          return typeof value === "function" ? value.bind(inst) : value;
        },
      }
    );

    if (true) {
      watch(
        isAuthenticated,
        (authed) => {
          if (authed) createEcho();
          else teardownEcho();
        },
        { immediate: true }
      );
    }

    return {
      provide: {
        echo
      }
    }
  },
})